<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("view") }} {{ $t("invoice") }}</div>
      <div class="d-flex">
        <a
          v-if="getInvoiceFileName"
          :href="BASE_URL + getInvoiceFileName"
          target="_blank"
          download
          class="btn-transparent"
          title="Download as PDF"
        >
          <button
            v-if="getInvoiceFileName"
            class="btn-blue"
            title="Download as PDF"
          >
            <img
              src="@/assets/img/icons/pdf-icon.svg"
              height="auto"
              width="25"
            />
          </button>
        </a>
        <router-link
          v-if="
            invoiceDetails[0] &&
              invoiceDetails[0].length > 0 &&
              invoiceDetails[0].i_lock !== 'Y'
          "
          class="btn-blue mx-2"
          :to="
            '/fnb/edit-invoice?i_number=' +
              invoiceQueryDetails.i_number +
              '&i_id=' +
              invoiceQueryDetails.i_id
          "
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="/fnb/invoice"
          >{{ $t("invoice") }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <caption class="text-nowrap font-weight-bold">{{
        $t("invoice")
      }}</caption>
      <table border="1" style="width:100%;margin-bottom:50px;">
        <tbody>
          <tr style="vertical-align:top;">
            <td style="width:50%;padding:5px;">
              <tr>
                <strong v-if="invoiceDetails[0]" style="font-size:16px;">{{
                  invoiceDetails[0].v_name
                }}</strong>
              </tr>
              <tr v-if="invoiceDetails[0]">{{
                invoiceDetails[0].v_address
              }}</tr>
              <!-- <tr>[City, ST ZIP]</tr> -->
              <tr v-if="invoiceDetails[0]"
                >{{ $t("phone") }}: {{ invoiceDetails[0].v_contact }}</tr
              >
              <!-- <tr>Fax: (000) 000-0000</tr> -->
              <!-- <tr>Website:</tr> -->
            </td>

            <td style="padding:5px;">
              <tr v-if="invoiceDetails[0]"
                >{{ $t("date") }}:
                {{ invoiceDetails[0].i_date | dateparse }}</tr
              >
              <tr v-if="invoiceDetails[0]"
                >{{ $t("invoice") }} {{ $t("number") }}:
                {{ invoiceDetails[0].i_number }}</tr
              >
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:var(--blue); color: white; text-align: center;">
          <tr>
            <th style="width:50%;padding:5px;">VENDOR</th>
            <th style="width:50%;padding:5px;">SHIP TO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style="padding:5px;"
            >Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum harum iure fuga velit voluptatem officiis reprehenderit voluptatibus omnis, nisi numquam facere excepturi illum, eius architecto eos quisquam quas! Quis, magnam.</td>
            <td style="padding:5px;"></td>
          </tr>
        </tbody>
      </table>-->

      <!-- <table border="1" style="width:100%;margin-bottom:50px;">
        <thead style="background:var(--blue); color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px">REQUISITIONER</th>
            <th style="padding:5px">SHIP VIA</th>
            <th style="padding:5px">F.O.B.</th>
            <th style="padding:5px">SHIPPING TERMS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>-->

      <table border="1" style="width:100%;margin-bottom:20px;">
        <thead style="background:var(--blue); color: #fff; text-align: center;">
          <tr>
            <th style="padding:5px; text-transform: uppercase;">{{
              $t("items")
            }}</th>
            <th style="padding:5px; text-transform: uppercase;">QTY</th>
            <!-- <th style="padding:5px; text-transform: uppercase;">UOM</th> -->
            <th style="padding:5px; text-transform: uppercase;"
              >gross amount</th
            >
            <th style="padding:5px; text-transform: uppercase;">Tax</th>
            <th style="padding:5px; text-transform: uppercase;">TOTAL</th>
          </tr>
        </thead>
        <tbody style="text-align:center;">
          <tr v-for="(raw, rawKey) in invoiceDetails" :key="rawKey">
            <td>{{ raw.rm_name }}</td>
            <td>{{ raw.ii_qty ? raw.ii_qty : "-" }}</td>
            <!-- <td>{{ raw.uom_unit }}</td> -->
            <td>{{ raw.ii_price }}</td>
            <td>{{ raw.ii_tax_amount }}</td>

            <td>{{ raw.ii_total_amount }}</td>
          </tr>
          <tr>
            <td style="vertical-align:top; padding: 2.5px 5px;"
              >Comments or Special Instructions</td
            >
            <td colspan="4" style="text-transform: uppercase;"></td>
          </tr>

          <tr>
            <td></td>
            <td>
              <strong style="text-transform: uppercase;">TOTAL</strong>
            </td>
            <td>
              <strong>{{ gross_amount }}</strong>
            </td>
            <td>
              <strong>{{ total_tax }}</strong>
            </td>
            <td>
              <strong>{{ currencyData.curr_code }} {{ grandTotal }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        grandTotal: null,
        gross_amount: null,
        total_tax: null,
        VendorsData: [],
        CinemaData: [],
        invoiceQueryDetails: {},
        invoiceDetails: [],
        RawMaterialsList: [],
        VendorList: [],
        Cinemas: [],
        RawMaterials: [],
        Vendors: [],
        measurements: [],
        selectedCinema: "",
        selectedRawMaterial: "",
        selectedVendor: "",
        selectedQuantity: "",
        selectedUom: "",
        po_number: "",
        totalTax: 0,
        currencyData: [],
      };
    },
    computed: {
      ...mapGetters(["getInvoiceFileName"]),
    },
    beforeMount() {
      this.invoiceQueryDetails.i_number = this.$route.query.i_number;
      this.invoiceQueryDetails.i_id = this.$route.query.i_id;
      this.getOrdersDetails();
    },
    mounted() {
      this.getCurrencyCode();
    },
    methods: {
      getCurrencyCode: function() {
        let payload = {
          tableName: "ms_currencies",
          curr_is_active: "Y",
          curr_id: this.secureStore.get("BRGLOPCUR"),
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.currencyData = data.Records[0];
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getOrdersDetails: function() {
        let loader = this.$loading.show();
        let payload = {
          i_id: this.invoiceQueryDetails.i_id,
        };
        PosFnbService.GetInvoiceDetails(payload)
          .then(async (response) => {
            const { data } = response;
            console.log("data.Records :", data.Records);

            if (data && data.status && data.Records.length > 0) {
              this.invoiceDetails = await data.Records.map((x) => {
                //     ...this.invoiceDetails,
                //   ...data.Records[0],
                //   i_date: new Date(data.Records[0].po_date),
                //   i_lock: "Y" ? true : false,
                //   i_is_active: "Y" ? true : false
                this.gross_amount += parseFloat(x.ii_price);
                this.total_tax += parseFloat(x.ii_tax_amount);
                this.grandTotal +=
                  parseFloat(x.ii_tax_amount) + parseFloat(x.ii_price);
                return x;
              });
              console.log("this.invoiceDetails :", this.invoiceDetails);
            } else {
              // this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(async () => {
            setTimeout(() => loader.hide(), 1100);
            if (this.invoiceDetails && this.invoiceDetails.length > 0) {
              await this.getVendorsList(this.invoiceDetails[0].v_id);
              await this.getCinemasList(this.invoiceDetails[0].cinema_id);
              await this.getRawMaterials(
                this.invoiceDetails,
                this.invoiceDetails[0].v_id
              );
            } else {
              this.$toasted.show("Invoice Details not found");
            }
          });
      },

      getCinemasList: function(cinema_id) {
        console.log("cinema_id :", this.invoiceDetails);
        let payload = {
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.Cinemas.map((x) => {
                if (x.cine_id == this.invoiceDetails[0].cinema_id) {
                  console.log("x :", x);
                  this.selectedCinema = x.cine_name;
                  this.CinemaData.push(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getunitsofmeasurements: function(uom_id, index) {
        let payload = {
          tableName: "ms_unit_of_measurement",
          uom_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.measurements = data.Records;
              this.measurements.map((x) => {
                if (x.uom_id == uom_id) {
                  this.VendorList[index].uom_unit = x.uom_unit;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getVendorsList: function(v_id) {
        console.log("v_id :", v_id);
        let payload = {
          tableName: "ms_vendors",
          v_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Vendors = data.Records;
              this.Vendors.map((x) => {
                if (x.v_id == v_id) {
                  console.log("x :", x);
                  this.invoiceDetails.v_id = v_id;
                  this.selectedVendor = x.v_name;
                  this.VendorsData.push(x);
                }
              });
              // this.Vendors.map((x, index) => {
              //   if (x.v_id == v_id) {
              //     this.VendorList.push({
              //       v_name: x.v_name,
              //       v_id: x.v_id,
              //       po_total_amount: po_total_amount,
              //       po_quantity: String(po_quantity),
              //       uom_unit: "",
              //       uom_id: String(uom_id),
              //       po_id: po_id
              //     });
              //   }
              // });
              // this.VendorList.map((x, index) => {
              //   this.getunitsofmeasurements(uom_id, index);
              // });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterials: function(Materials, vendor_id) {
        let loader = this.$loading.show();
        let payload = {
          vendor_id,
        };

        PosFnbService.GetVendorRateDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RawMaterials = data.Records;
              Materials.map((x) => {
                this.totalTax += x.poi_tax_amount;
                this.invoiceDetails.po_sub_total_amount =
                  this.invoiceDetails.po_total_amount - this.totalTax;
                let array = data.Records.filter(
                  ({ rm_id }) => rm_id === x.rm_id
                );
                this.RawMaterialsList.push({
                  rm_name: x.rm_name,
                  rm_id: x.rm_id,
                  rm_description: x.rm_description,
                  poi_qty: String(x.poi_qty),
                  po_quantity: String(x.poi_qty),
                  poi_price: String(x.poi_price),
                  uom_unit: x.uom_unit,
                  uom_id: x.uom_id,
                  poi_id: x.poi_id,
                  poi_is_active: true,
                  vendor_rate_id: x.vendor_rate_id,
                  singlItemPrice: parseFloat(x.poi_price) / x.poi_qty,
                  SelectedRawMaterial: array.length > 0 ? array[0] : {},
                  TotalTax: this.totalTax,
                  FinalSubTotal: this.invoiceDetails.po_sub_total_amount,
                });

                // this.RawMaterialsList.map(x => {
                //   console.log('x.singleTaxPrice :', x.singleTaxPrice);
                //   this.totalTax += x.singleTaxPrice;
                // });
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError)
          .finally(async () => {
            console.log(
              "object :",
              this.invoiceDetails,
              this.VendorsData,
              this.CinemaData,
              this.RawMaterialsList
            );
            setTimeout(() => {
              this.$store.dispatch("FETCH_INVOICE_DETAILS", {
                PurchasOrderDetails: this.invoiceDetails,
                VendorsDetails: this.VendorsData,
                CinemasDetails: this.CinemaData,
                RawMaterialsDetails: this.RawMaterialsList,
                BasicDetails: {
                  curr_code: this.currencyData.curr_code,
                  total_tax: this.total_tax,
                  gross_amount: this.gross_amount,
                  grandTotal: this.grandTotal,
                },
              });
            }, 2000);
            setTimeout(() => loader.hide(), 2000);
          });
        // let payload = {
        //   tableName: "ms_raw_materials",
        //   rm_is_active: "Y"
        // };
        // MasterService.GetActiveList(payload)
        //   .then(response => {
        //     const { data } = response;
        //     if (data && data.status && data.Records.length > 0) {
        //       this.RawMaterials = data.Records;
        //       this.RawMaterialsList.push({
        //         rm_name: x.rm_name,
        //         rm_id: x.rm_id,
        //         rm_description: x.rm_description,
        //         poi_qty: String(x.poi_qty),
        //         po_quantity: String(x.poi_qty),
        //         poi_price: String(x.poi_price),
        //         uom_unit: x.uom_unit,
        //         uom_id: x.uom_id,
        //         poi_id: x.poi_id,
        //         poi_is_active: true,
        //         vendor_rate_id: x.vendor_rate_id
        //       });
        //       this.RawMaterialsList = this.RawMaterialsList.map(x => {
        //         x["singlItemPrice"] = parseFloat(x.poi_price) / x.poi_qty;
        //         return x;
        //       });
        //     } else {
        //       this.$toasted.show(data.message);
        //     }
        //   })
        //   .catch(this._CatchError); //message
      },
    },
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/InvoiceComponents/viewInvoice.vue